import { getDescriptionForPath } from '../../../../../config/configEntry';
import SubjectSelect from '../../../subjectSelect/SubjectSelect';
import classes from './DesignTextsSection.module.css';

const ADMIN_TEXT_FIELD_KEYS = [
  'headerBotName',
  'headerDescription',
  'botTitle',
  'botSubTitle',
  'welcomeMessage',
  'typeHereText',
  'urlClickText',
  'nonAuthText',
];

const DesignTextsSection = ({ draft, setDraft, descriptions, onSubjectSelect }) => {
  const setTextField = (key, value) => {
    setDraft(d => ({ ...d, [key]: value }));
  };

  return (
    <div className={classes.List}>
      <SubjectSelect
        subjectName={draft.subjectName ?? ''}
        subjectImageUrl={draft.subjectImageUrl ?? ''}
        domain={draft.domain ?? ''}
        label={getDescriptionForPath(descriptions, 'subjectSelect', 'subjectSelect')}
        onSelect={({ subjectName, subjectImageUrl, domain }) => {
          setDraft(d => ({
            ...d,
            subjectName,
            subjectImageUrl,
            domain,
          }));
          onSubjectSelect?.({ subjectName, subjectImageUrl, domain });
        }}
      />
      {ADMIN_TEXT_FIELD_KEYS.map(key =>
        <div key={key} className={classes.Field}>
          <label className={classes.Label} htmlFor={key}>
            {getDescriptionForPath(descriptions, key, key)}
          </label>
          <input
            id={key}
            className={classes.TextInput}
            value={draft[key] ?? ''}
            onChange={e => setTextField(key, e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default DesignTextsSection;
